import axiosInstance from '../apiService';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = 'QuoteLineItem/';

const getQuoteLineItems = async (quoteId) => axiosInstance.get(`${ENDPOINTORIGIN}GetQuoteLineItems?quoteId=${quoteId}`, constants.REQUIRE_INTERCEPTORS);

const getQuoteLineItemById = async (quoteLineItemId) => axiosInstance.get(`${ENDPOINTORIGIN}GetQuoteLineItemById?quoteLineItemId=${quoteLineItemId}`, constants.REQUIRE_INTERCEPTORS);

const createQuoteLineItem = async (quoteLineItem) => axiosInstance.post(`${ENDPOINTORIGIN}CreateQuoteLineItem`, quoteLineItem, constants.REQUIRE_INTERCEPTORS);

const updateQuoteLineItem = async (model) => axiosInstance.put(`${ENDPOINTORIGIN}UpdateQuoteLineItem`, model, constants.REQUIRE_INTERCEPTORS);

const deleteQuoteLineItem = async (id) => axiosInstance.delete(`${ENDPOINTORIGIN}DeleteQuoteLineItem?id=${id}`, constants.REQUIRE_INTERCEPTORS);

export {
  getQuoteLineItems,
  getQuoteLineItemById,
  createQuoteLineItem,
  updateQuoteLineItem,
  deleteQuoteLineItem,
};